import React from 'react';

const SavingsBlock = (props) => {

    const totalSave = props.state.category === 'own' ? '$'+props.state.totalBYOSave 
        : (props.state.category === 'hpc' ? (props.state.cores > 48 ? 'N/A' 
        : '$'+props.state.totalComputeSave) : '$'+props.state.totalSave);
    const percentage = props.state.category === 'own' ? props.state.percentageBYO+'%'
        : (props.state.category === 'hpc' ? (props.state.cores > 48 ? 'N/A' 
        : props.state.totalComputePercentage+'%') : props.state.percentage+'%');

    const onClickHandler = () => {
        window.open(
            'https://myservices.us.oraclecloud.com/mycloud/signup',
            '_blank'
        );
    };

    return (
        <div className="row savingsBlock">
            <div className="col-xs-3">
                <div className="title6">Total Estimated Savings/mo</div>
                <span className="comparisonAmt redTotal title4">{totalSave}</span>
            </div>
            <div className="col-xs-3">
                <div className="title6">Saving Percentage</div>
                <span className="comparisonAmt redTotal title4">{percentage}</span>
            </div>
            <div className="col-xs-6 noPadRight">
                <button className="blackBtn" onClick={e => onClickHandler(props.id)}>Try Oracle Cloud For Free</button>
            </div>
        </div>
    );
};

export default SavingsBlock;
